import React, { useEffect, useState } from 'react'
import { sortDisplayOrder } from '../../../../services/util';
import { getTickets } from '../../../../revampCRUD/ticketsNforms.crud';
import customToast from '../../../../components/common/basic/Toast';
import Select from 'react-select';
import { getCoupons } from '../../../../revampCRUD/copounNcharges.crud';

const customStyles = {
    option: (styles, { isFocused, isSelected }) => ({
        ...styles,
        background: isSelected ? "#002E6E" : isFocused ? "#e2e8f0" : "white",
        margin: "0px",
        color: isSelected ? "white" : isFocused ? "#1a202c" : "#4a5568",
        zIndex: 10,
        overflowX: "hidden",
        wordBreak: "break-word",
        cursor: "pointer",
    }),
    menu: (provided) => ({
        ...provided,
        marginTop: "2px",
        overflow: "hidden",
        zIndex: 10,
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    dropdownIndicator: (base) => ({
        ...base,
        color: "#1E1F24",
        padding: "5px 8px",
        zIndex: 10,
        "&:hover": {
            color: "#1E1F24",
        },
    }),
    control: (base, state) => ({
        ...base,
        border: state.isFocused ? "1px solid #002E6E" : "1px solid #cdd4db",
        boxShadow: "none",
        borderRadius: "2px",
        minHeight: "36px",
        maxHeight: "2.5em",
    }),
};
const AccessCodeDropdown = ({ eventId, setSelectedTicket, selectedTicket,ticketsData,setTicketsData,  selectedAccessCode,
  setSelectedAccessCode }) => {
    const [loading, setLoading] = useState(true);
    const [selectedOption, setSelectedOption] = useState(null);
    const [filter, setFilter] = useState({ key: "", coupons: [], tickets: [] });
     const [accessCodesData, setAccessCodesData] = useState([]);
     const getAccessCodes = async () => {
      setLoading(true)
       try {
         const res = await getCoupons({
           eventId: eventId,
           codeType: 2,
           ticket_ids: selectedTicket?.value
         });
           const mapped = res?.data?.coupons?.map((coupon) => ({
               value: coupon.coupon_id,
               label: coupon.coupon_code,
               original: coupon, 
           }));
           setAccessCodesData(mapped);
           setLoading(false)
       } catch (err) {
         console.log(err);
       }
     };
    const handleChange = (selectedOption) => {
       setSelectedAccessCode(selectedOption)
    };
     useEffect(() => {
       getAccessCodes();
     }, [])

  
    return (
        <div>
            <Select
                value={selectedAccessCode}
                onChange={handleChange}
                options={accessCodesData}
                placeholder={`${loading ? "Loading access code" : "Select access code"}`}
                styles={customStyles}
                isDisabled={loading || accessCodesData.length === 0}
                // menuPortalTarget={document.body}
                // menuPlacement="auto"
                isSearchable
            />
        </div>
    )
}

export default AccessCodeDropdown
